import { render } from "./dialog-column.vue?vue&type=template&id=5d630ab6"
import script from "./dialog-column.vue?vue&type=script&lang=js"
export * from "./dialog-column.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/crud/dialog/dialog-column.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d630ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d630ab6', __exports__)) {
    console.log('reload')
    api.reload('5d630ab6', __exports__)
  }
  
  module.hot.accept("./dialog-column.vue?vue&type=template&id=5d630ab6", () => {
    console.log('re-render')
    api.rerender('5d630ab6', render)
  })

}


export default __exports__